export default __webpack_public_path__ + "/assets/fonts/inter-latin-ext-wght-normal.woff2";